import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export default function ResultActions({ isSuccess, isPending, verifying, onCheckStatus, onViewBookings, onBookAnother, onTryAgain }) {
  if (isSuccess) {
    return (
      <div className="flex gap-3">
        <Button onClick={onViewBookings} className="flex-1">
          View My Bookings
        </Button>
        <Button onClick={onBookAnother} variant="outline" className="flex-1">
          Book Another Court
        </Button>
      </div>
    );
  }

  if (isPending) {
    return (
      <div className="flex gap-3">
        <Button
          onClick={onCheckStatus}
          className="flex-1 bg-emerald-600 hover:bg-emerald-700"
          disabled={verifying}
        >
          {verifying ? (
            <div className="flex items-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" />
              <span>Checking...</span>
            </div>
          ) : (
            'Check Payment Status'
          )}
        </Button>
        <Button onClick={onViewBookings} variant="outline" className="flex-1">
          View Bookings
        </Button>
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <Button onClick={onTryAgain} className="flex-1">
        Try Again
      </Button>
      <Button onClick={onViewBookings} variant="outline" className="flex-1">
        View Bookings
      </Button>
    </div>
  );
}
